<template>
  <div>
    <a-modal
      title="常用语句"
      :visible="visible"
      @cancel="handleCancel"
       width="800px"
       :footer="null"
    >
      <a-input-search style="width: 50%;margin-bottom:10px;" default-value="" placeholder="标题、查询语句、创建人"  @search="onSearch" />
        
        <a-table :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="id" >
                <template slot="operation" slot-scope="text, record">
                    <div>
                        <span>
                            <a-popconfirm title="确定要删除？?" @confirm="() => handleDelete(record.id)">
                            <a>删除</a>
                            </a-popconfirm>
                        </span>
                        <span>
                            <a-button type="link" @click="handleUse(record.querystr)">使用</a-button>
                        </span>
                    </div>
             
                </template>
                ctime
                <template slot="ctime" slot-scope="text">
                   <span>{{text.slice(2,text.length - 2)}}</span>
                </template>
        </a-table>
        <br>
        <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange" style="float:right;margin-bottom:20px;" show-less-items />
        <br>
    </a-modal>
  </div>
</template>
<script>
let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns=[
    // {
    //     title: '序号',
    //     align: 'center',
    //     width: 50,
    //     customRender: (text, record, index) => {
    //         let { current, pageSize } = pagination;
    //         return (Number(current) - 1) * Number(pageSize) + index + 1;
    //     }
    // },
    {
        title: '标题',
        dataIndex: 'title',
        align: 'left',
        width: 130,

    },{
        title: '查询语句',
        dataIndex: 'querystr',
        align: 'left',
        ellipsis: true,
        width: 200,

    },{
        title: '创建时间',
        dataIndex: 'createtime',
        align: 'left',
        width: 130,
        scopedSlots: { customRender: 'ctime' },

    },{
        title: '创建人',
        dataIndex: 'createuser',
        align: 'left',
        width: 80,

    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'left',
        width:100,
        scopedSlots: { customRender: 'operation' },
    }
]
export default {
    
    data() {
        return {
            tLoading:false,
            columns,
            data:[],
            pagination,
            visible:false,
            searchVal:''
        };
    },
    props:{
        project:String,
    },
    methods: {
        handleUse(qstr){
            this.$emit("sqlselected",qstr)
            this.handleCancel()
        },
        handleDelete(rid){
            this.tLoading = true;
            let that = this;
            let c_params = {
                id:rid,
                urlparams:false,
            }
           
            that.$store.dispatch({
                type: "logservice/deletelogsql",
                params:c_params,
            }).then((res)=>{
                if(res.data.success == 1){
                    that.onModalInit(1)
                }
                else{
                    that.message.error('调用接口失败')
                }
                that.tLoading = false;
            }).catch(() => {
                that.tLoading = false;
            });
        },
        onSearch(value){
            this.searchVal = value;
            this.onModalInit(1); 
        },
        handleCancel() {
            this.visible = false;
            this.tLoading = false;
            this.searchVal = "";
        },
        handlePageChange(params_page){
            this.onModalInit(params_page)
        },
        onModalInit(pageNum){
            this.visible = true;
            this.tLoading = true;
            let that = this;
            let c_params = {
                keyword:that.searchVal,
                pageSize:that.pagination.pageSize,
                page:pageNum,
                urlparams:false,
            }
           
            that.$store.dispatch({
                type: "logservice/querylogsql",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                if(res.data.success == 1){
                    let result = res.data.data;
                    this.data = result.list;
                    this.pagination.total = result.totalRecords;
                    this.pagination.pageSize = result.pageSize;
                    this.pagination.current = result.page;
                }
                else{
                    that.message.error('调用接口失败')
                }
                that.tLoading = false;
            }).catch(() => {
                that.tLoading = false;
            });
        }
    },
};
</script>
